import { useState } from 'react';
import { useRef } from 'react';
import { useEmailState } from 'components/EmailStateProvider';
import ViewMailMergeModal from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/ViewMailMergeModal';
import RemoveMailMergeDataModal from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/RemoveMailMergeDataModal';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import RecipientsActionsMenu from './RecipientsActionsMenu';
import RemoveRecipientsModal from 'components/Dashboard/Influence/CrmEmails/CrmContactsSelect/RemoveRecipientsModal';

const SelectedContactsQntty = (props) => {
  const { emailState, setEmailState } = useEmailState();
  const { emailSelectedContacts, currentEmailDetails, isRemoveMailMergeDataModalOpen } = emailState;
  const { hasMailMergeData, crmEmailId: id } = currentEmailDetails;

  const { sentEmail, setActiveTab, setActiveRecipientsOption, selectRef, refreshEmailData } = props;
  const selectedContacts = emailSelectedContacts.length || 0;
  const [showActions, setShowActions] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isRemoveRecipientsModalOpen, setIsRemoveRecipientsModalOpen] = useState(false);

  const actionsContainer = useRef(null);

  const setIsRemoveMailMergeDataModalOpen = (value) => {
    setEmailState('isRemoveMailMergeDataModalOpen', value);
  };

  return (
    <div
      className={`selected-contacts-qntty ${sentEmail ? 'selected-contacts-qntty-sent' : ''} ${
        selectedContacts >= 1 ? 'd-flex' : ''
      }`}
      onClick={() => {
        if (sentEmail) {
          setActiveTab('Recipients');
          setActiveRecipientsOption('All');
        }
      }}
    >
      {selectedContacts >= 1 && (
        <>
          {thousandCommas(selectedContacts)} recipient{selectedContacts > 1 ? 's' : ''}
        </>
      )}
      {!sentEmail && (
        <div
          className='position-relative d-inline-block ml-1 remove-all-recipients-action'
          ref={actionsContainer}
          style={{ marginRight: '3px', marginTop: '-3px' }}
        >
          <button
            className={`general-button circle-button hover-background-gray-05 p-1`}
            onClick={(e) => {
              e.stopPropagation();
              setShowActions(!showActions);
            }}
          >
            <span className='icon-three-dots text-main-blue-40' />
          </button>
          {showActions && (
            <>
              <div className='general-close-background z-max' onClick={() => setShowActions(false)} />
              <RecipientsActionsMenu
                selectedContacts={selectedContacts}
                hasMailMergeData={hasMailMergeData}
                setIsViewModalOpen={setIsViewModalOpen}
                setIsRemoveMailMergeDataModalOpen={setIsRemoveMailMergeDataModalOpen}
                setShowActions={setShowActions}
                selectRef={selectRef}
                setIsRemoveRecipientsModalOpen={setIsRemoveRecipientsModalOpen}
              />
            </>
          )}
        </div>
      )}
      <ViewMailMergeModal isOpen={isViewModalOpen} setIsOpen={setIsViewModalOpen} />
      <RemoveMailMergeDataModal
        id={id}
        isOpen={isRemoveMailMergeDataModalOpen}
        setIsOpen={setIsRemoveMailMergeDataModalOpen}
        refreshEmailData={refreshEmailData}
      />
      <RemoveRecipientsModal
        isOpen={isRemoveRecipientsModalOpen}
        setIsOpen={setIsRemoveRecipientsModalOpen}
        selectRef={selectRef}
      />
    </div>
  );
};
export default SelectedContactsQntty;
